/*
    2020-7-20
    ZS
    大屏仪表板
*/ 
<template>
  <div class="machine BSmainWrap">
     
      
        
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;">
          
            <!-- <div> -->
          <div style="position: relative;">
              <!-- 蒙版 -->
              <div class="mask" :class="{maskLong:lineVal[0] === 2  || lineVal[0] === 4,offlineMask:getMachineInfo.machineStatus === 5, notConnectedMask: getMachineInfo.machineStatus === 0}">
                <p v-if="getMachineInfo.machineStatus === 5">{{$t('MachineDashBoard.maskOffline')}}</p>
                <p v-else-if="getMachineInfo.machineStatus === 0">{{$t('MachineDashBoard.maskNotConnected')}}</p>
                <p v-else-if="getMachineInfo.machineStatus === 4">{{$t('MachineDashBoard.maskNoproduction')}}</p>
              </div>
            <!-- </div> -->
            <!-- 机器信息 -->
            <div class="machineInfo">
              <!-- 如果机器id=131 更改背景图 -->
              <div class="title_bg" :class="{'special_bg': this.machineId===131}"></div>
              
              <!-- 新增机械状态 和班组 -->
              <div class="statusWrap">
                <div class="status">
                  <span>{{$t('MachineDashBoard.infoTitle1')}}</span>
                  <span v-if="$store.state.lang ===0" :style="{color: stateColor}">{{machintLine[getMachineInfo.machineStatus]}}</span>
                  <span v-else  :style="{color: stateColor}">{{machintLineCh[getMachineInfo.machineStatus]}}</span>
                </div>
                <div class="currentShift">
                  <span>{{$t('MachineDashBoard.infoTitle3')}}:</span>
                  <span>{{getMachineInfo.currentShift +' '+ $t('MachineDashBoard.class3')}} </span>
                </div>
              </div>
              <el-row class="groupWrap">
                <el-col :span="6">
                  <div class="stateWrap last">
                    <div>
                      <p class="val">{{getMachineInfo.lastCycle}} <span>s</span></p>
                      <p class="dis">{{$t('MachineDashBoard.stateDescribe1')}}</p>
                    </div>
                    <div class="bottomIcon">
                      <historyIcon title=""/>
                    </div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="stateWrap average">
                    <div>
                      <p class="val">{{getMachineInfo.averageCycle}} <span>s</span></p>
                      <p class="dis">{{$t('MachineDashBoard.stateDescribe3')}}</p>
                    </div>
                    <div class="bottomIcon">
                      <clockIcon title=""/>
                    </div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="stateWrap best">
                    <div>
                      <p class="val">{{getMachineInfo.bestCycle}} <span>s</span></p>
                      <p class="dis">{{$t('MachineDashBoard.stateDescribe4')}}</p>
                    </div>
                    <div class="bottomIcon">
                      <p>{{getMachineInfo.bestTireTime}}</p>
                      <rightClockIcon />
                    </div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="stateWrap current">
                    <div>
                      <p class="val">{{getMachineInfo.currentProductivity}}</p>
                      <p class="tires" >{{this.productUnit}}</p>
                      <p class="dis">{{$t('MachineDashBoard.stateDescribe7')}}</p>
                    </div>
                    <div class="bottomIcon">
                      <coinsIcon />
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            
            <!-- 各工位循环周期时间 -->
            <div v-show="lineVal[0] !== 3" class="cycleTime">
              <h2 class="cycleTime-title">{{$t('MachineDashBoard.cycletime')}}</h2>
              <div>
                <div class="cycleBodyHead">
                  <div class="headLeft">
                    <div class="cycleHead-item cycleHead-item-active">{{$t('MachineDashBoard.station')}}</div>
                  </div>
                  <div class="cycle-headRight">
                    <div class="cycleHead-item">{{$t('MachineDashBoard.current')}}</div>
                    <div class="cycleHead-item">{{$t('MachineDashBoard.best')}}</div>
                    <div class="cycleHead-item">{{$t('MachineDashBoard.average')}}</div>
                    <div class="cycleHead-item">{{$t('MachineDashBoard.output')}}</div>
                  </div>
                </div>
                <div class="cycleBodyContent">
                  <div class="cycleContent-item">
                    <div class="cycleImg-box">
                      <div>
                        <img class="cycleImg" src="../assets/img/cycleTime/cycle-CC.png"/>
                      </div>
                      <div class="cycleModel">{{$t('MachineDashBoard.CC')}}</div>
                    </div>
                    <div class="ContentItem-left">
                      <div class="cycle-leftItem">
                        <div class="cycle-second">
                          <span v-show="CC.currentCycleTime || CC.currentCycleTime===0" class="cycle-secondNum">{{CC.currentCycleTime}}</span>
                          <span v-show="CC.currentCycleTime || CC.currentCycleTime===0" class="cycle-secondS">s</span>
                          <span v-show="!CC.currentCycleTime && CC.currentCycleTime!==0" class="cycle-secondNum">-</span>
                        </div>
                        <div class="time">{{CC.currentCycleDate}}</div>
                      </div>
                      <div class="short-border"></div>
                      <div class="cycle-leftItem">
                        <div class="cycle-second">
                          <span v-show="CC.bestCycle || CC.bestCycle===0" class="cycle-secondNum">{{CC.bestCycle}}</span>
                          <span v-show="CC.bestCycle || CC.bestCycle===0" class="cycle-secondS">s</span>
                          <span v-show="!CC.bestCycle && CC.bestCycle!==0" class="cycle-secondNum">-</span>
                        </div>
                        <div class="time">{{CC.bestCycleDate}}</div>
                      </div>
                      <div class="short-border"></div>
                      <div class="cycle-leftItem">
                        <div class="cycle-second">
                          <span v-show="CC.averageCycle || CC.averageCycle===0" class="cycle-secondNum">{{CC.averageCycle}}</span>
                          <span v-show="CC.averageCycle || CC.averageCycle===0" class="cycle-secondS">s</span>
                          <span v-show="!CC.averageCycle && CC.averageCycle!==0" class="cycle-secondNum">-</span>
                        </div>
                      </div>
                      <div class="short-border"></div>
                      <div class="cycle-leftItem">
                        <div class="cycle-second">
                          <span v-show="CC.event || CC.event===0" class="cycle-secondNum lastNum">{{CC.event}}</span>
                          <span v-show="!CC.event && CC.event!==0" class="cycle-secondNum">-</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="cycleContent-item">
                    <div class="cycleImg-box">
                      <div>
                        <img class="cycleImg" src="../assets/img/cycleTime/cycle-BT.png"/>
                      </div>
                      <div class="cycleModel">{{$t('MachineDashBoard.BT')}}</div>
                    </div>
                    <div class="ContentItem-left">
                      <div class="cycle-leftItem">
                        <div class="cycle-second">
                          <span v-show="BT.currentCycleTime || BT.currentCycleTime===0" class="cycle-secondNum">{{BT.currentCycleTime}}</span>
                          <span v-show="BT.currentCycleTime || BT.currentCycleTime===0" class="cycle-secondS">s</span>
                          <span v-show="!BT.currentCycleTime && BT.currentCycleTime!==0" class="cycle-secondNum">-</span>
                        </div>
                        <div class="time">{{BT.currentCycleDate}}</div>
                      </div>
                      <div class="short-border"></div>
                      <div class="cycle-leftItem">
                        <div class="cycle-second">
                          <span v-show="BT.bestCycle || BT.bestCycle===0" class="cycle-secondNum">{{BT.bestCycle}}</span>
                          <span v-show="BT.bestCycle || BT.bestCycle===0" class="cycle-secondS">s</span>
                          <span v-show="!BT.bestCycle && BT.bestCycle!==0" class="cycle-secondNum">-</span>
                        </div>
                        <div class="time">{{BT.bestCycleDate}}</div>
                      </div>
                      <div class="short-border"></div>
                      <div class="cycle-leftItem">
                        <div class="cycle-second">
                          <span v-show="BT.averageCycle || BT.averageCycle===0" class="cycle-secondNum">{{BT.averageCycle}}</span>
                          <span v-show="BT.averageCycle || BT.averageCycle===0" class="cycle-secondS">s</span>
                          <span v-show="!BT.averageCycle && BT.averageCycle!==0" class="cycle-secondNum">-</span>
                        </div>
                      </div>
                      <div class="short-border"></div>
                      <div class="cycle-leftItem">
                        <div class="cycle-second">
                          <span v-show="BT.event || BT.event===0" class="cycle-secondNum lastNum">{{BT.event}}</span>
                          <span v-show="!BT.event && BT.event!==0" class="cycle-secondNum">-</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="cycleContent-item">
                    <div class="cycleImg-box">
                      <div>
                        <img class="cycleImg" src="../assets/img/cycleTime/cycle-SP.png"/>
                      </div>
                      <div class="cycleModel">{{$t('MachineDashBoard.SP')}}</div>
                    </div>
                    <div class="ContentItem-left">
                      <div class="cycle-leftItem">
                        <div class="cycle-second">
                          <span v-show="SP.currentCycleTime || SP.currentCycleTime===0" class="cycle-secondNum">{{SP.currentCycleTime}}</span>
                          <span v-show="SP.currentCycleTime || SP.currentCycleTime===0" class="cycle-secondS">s</span>
                          <span v-show="!SP.currentCycleTime && SP.currentCycleTime!==0" class="cycle-secondNum">-</span>
                        </div>
                        <div class="time">{{SP.currentCycleDate}}</div>
                      </div>
                      <div class="short-border"></div>
                      <div class="cycle-leftItem">
                        <div class="cycle-second">
                          <span v-show="SP.bestCycle || SP.bestCycle===0" class="cycle-secondNum">{{SP.bestCycle}}</span>
                          <span v-show="SP.bestCycle || SP.bestCycle===0" class="cycle-secondS">s</span>
                          <span v-show="!SP.bestCycle && SP.bestCycle!==0" class="cycle-secondNum">-</span>
                        </div>
                        <div class="time">{{SP.bestCycleDate}}</div>
                      </div>
                      <div class="short-border"></div>
                      <div class="cycle-leftItem">
                        <div class="cycle-second">
                          <span v-show="SP.averageCycle || SP.averageCycle===0" class="cycle-secondNum">{{SP.averageCycle}}</span>
                          <span v-show="SP.averageCycle || SP.averageCycle===0" class="cycle-secondS">s</span>
                          <span v-show="!SP.averageCycle && SP.averageCycle!==0" class="cycle-secondNum">-</span>
                        </div>
                      </div>
                      <div class="short-border"></div>
                      <div class="cycle-leftItem">
                        <div class="cycle-second">
                          <span v-show="SP.event || SP.event===0" class="cycle-secondNum lastNum">{{SP.event}}</span>
                          <span v-show="!SP.event && SP.event!==0" class="cycle-secondNum">-</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
         
        </el-scrollbar>
      
  </div>
</template>

<script>
import clockIcon from "vue-material-design-icons/ClockOutline.vue"
import rightClockIcon from "vue-material-design-icons/Update.vue"
import timerIcon from "vue-material-design-icons/Timer.vue"
import settingsIcon from "vue-material-design-icons/Settings.vue"
import helpIcon from "vue-material-design-icons/HelpCircle.vue"
import messageIcon from "vue-material-design-icons/MessageAlert.vue"
import alertIcon from "vue-material-design-icons/Alert.vue"
import closeIcon from "vue-material-design-icons/CloseCircle.vue"
import accountIcon from "vue-material-design-icons/AccountSupervisor.vue"
import historyIcon from "vue-material-design-icons/History.vue"
import coinsIcon from "vue-material-design-icons/Coins.vue"
import downLoadIcon from "vue-material-design-icons/CloudDownload.vue"

import { formatDate } from '../assets/js/date.js'
import { Loading } from 'element-ui'
export default {
  name: 'machine',
  components: {
    clockIcon,
    rightClockIcon,
    timerIcon,
    settingsIcon,
    helpIcon,
    messageIcon,
    alertIcon,
    closeIcon,
    accountIcon,
    historyIcon,
    coinsIcon,
    downLoadIcon
  },
  data () {
    return {
      lineVal: [],
      saveLineVal: '',
      // 联动选择器数据
      options: [],
      // 机器ID
      machineId: 101,
      // 获取的机器信息
      getMachineInfo: {
        nameEn: '',
        lineNameEn: '',
        shopNameEn: '',
        factoryNameEn: '',
        machineStatus: '',
        currentDimension: '',
        currentShift: '',
        continuousRunning: '',
        currentProductivity: '',
        lastCycle: '',
        standardCycle: '',
        averageCycle: '',
        bestCycle: '',
        shiftPlan: '',
        estimateProductivity: ''
      },
      // 日志页数
      pageNo: 1,
      // 日志总页数
      totalPage: 1000,
      // 表格数据
      tableData: null,
      dataRun: null,
      isFavorited: null,
      // loading wrap
      loadingInstance: '',
      websock: null,
      show: true,
      showIndex: -1,
      timeList: [],
      timePageSize: null,
      timeNowPage: 1,
      //各工位循环周期时间的变量
      CC:{},
      BT:{},
      SP:{},
      cycleShowId:'',
      cycleShowFactoryId:'',
      // 设备运行情况
      machintLine: ['Not Connected', 'running', 'standby', 'fault', 'stop', 'offline'],
      machintLineCh: ['未接入', '运行中', '待机', '故障', '停止', '离线'],
      stateColor: '#fff',
      productUnit: '',
      defaultFactoryId:''
    }
  },
  filters: {
    formatDateYear (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy')
    },
    formatDateManth (time) {
      var date = new Date(time)
      return formatDate(date, 'MM')
    },
    formatDateDay (time) {
      var date = new Date(time)
      return formatDate(date, 'dd')
    },
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  },
  created() {
    //获取页面默认的工厂id和机器id，以判断 各工位循环周期时间 是否显示
    this.lineVal = [Number(this.$store.state.defaultShopId), Number(this.$store.state.defaultId)]
    this.defaultFactoryId = Number(this.$store.state.defaultFactoryId)
  },
  mounted () {
    
    this.getId()
    this.$store.commit('authority' , this.$route.name)
  },
  destroyed () {
    // clearTimeout(this.dataRun)
    this.websock.close()
    this.loadingInstance.close()
  },
  methods: {
    getId(){
      let _this = this
      this.fullscreenLoading = true
      this.axios({
        method: 'get',
        url: '/url/getBigscreenMachine'
      }).then(function(res){
        if (res.data.success === 'false') {
          _this.$message.error(res.data.msg);
        }else{
          _this.machineId = res.data.machine.id
          _this.initWebSocket()
        }
      })
    },
    // 初始化weosocket
    initWebSocket(){ 
      let _this = this
      _this.loadingInstance = Loading.service({ fullscreen: true })
      _this.websock = new WebSocket("ws://" + _this.$store.state.websocketws+_this.$store.state.newroute + "/websocket-dashboardstation")
      // 接收服务器发来的消息
      _this.websock.onmessage = function (e) {
        var data = JSON.parse(e.data)
        if (data['info'] !== null) {
          var info = JSON.parse(data['info'])
          if (info !== null) {
            _this.getMachineInfo = info
            // 动态修改机器运行状态颜色
            switch (info.machineStatus) {
              case 1:
                _this.stateColor = '#0bd70b'
                break;
              case 2:
                _this.stateColor = '#cfcf0b'
                break;
              case 3:
                _this.stateColor = '#d43030'
                break;
              case 4:
                _this.stateColor = '#4866ea'
                break;
              case 5:
                _this.stateColor = '#808080'
                break;
              case 0:
                _this.stateColor = '#383838'
                break;
            }
            if (_this.lineVal[0] === 3 && info.machineCategoryId == 3) {
              _this.productUnit = _this.$t('MachineDashBoard.class4')
            }else{
              _this.productUnit = _this.$t('MachineDashBoard.class1')
            }
            
            let num = new Number(info.continuousRunning)
            _this.getMachineInfo.continuousRunning = num.toFixed(1)
            
            if ( isNaN(info.lastCycle)) {
              _this.getMachineInfo.lastCycle = '-'
            } else {
              let num1 = new Number(info.lastCycle)
              _this.getMachineInfo.lastCycle = num1.toFixed(0)
            }
            if (isNaN(info.standardCycle)) {
              _this.getMachineInfo.standardCycle = '-'
            } else {
              let num2 = new Number(info.standardCycle)
              _this.getMachineInfo.standardCycle = num2.toFixed(0)
            }
            if (isNaN(info.averageCycle)) {
              _this.getMachineInfo.averageCycle = '-'
            } else {
              let num3 = new Number(info.averageCycle)
              _this.getMachineInfo.averageCycle = num3.toFixed(0)
            }
            if (isNaN(info.bestCycle)) {
              _this.getMachineInfo.bestCycle = '-'
            } else {
              let num4 = new Number(info.bestCycle)
              _this.getMachineInfo.bestCycle = num4.toFixed(0)
            }
            if (isNaN(info.shiftPlan)) {
              _this.getMachineInfo.shiftPlan = '-'
            } else {
              let num5 = new Number(info.shiftPlan)
              _this.getMachineInfo.shiftPlan = num5.toFixed(0)
            }
            if (isNaN(info.estimateProductivity)) {
              _this.getMachineInfo.estimateProductivity = '-'
            } else {
              let num6 = new Number(info.estimateProductivity)
              _this.getMachineInfo.estimateProductivity = num6.toFixed(0)
            }
            if (isNaN(info.currentProductivity)) {
              _this.getMachineInfo.currentProductivity = '-'
            } else {
              let num7 = new Number(info.currentProductivity)
              _this.getMachineInfo.currentProductivity = num7.toFixed(0)
            }
          }
        }
        if (data['logs'] !== null) {
          var logs = JSON.parse(data['logs'])
          if (logs) {
            _this.tableData = logs.rows
            _this.totalPage = logs.total
          }
        }
        _this.timeList = data['timeList']
        let total = _this.timeList.length/10
        if (Number.isInteger(total)) {
          _this.timePageSize = total
        } else {
          _this.timePageSize = Number.parseInt(total) + 1
        }
        _this.loadingInstance.close()

        //各工位循环周期时间

        if(_this.lineVal[0] !== 3){
          let machineParts = JSON.parse(data.station)
          let CC = JSON.parse(machineParts.CC)
          let BT = JSON.parse(machineParts.BT)
          let SP = JSON.parse(machineParts.SP)
          //Math.round(number * 100) / 100  四舍五入的方法
          CC.averageCycle = Math.round(CC.averageCycle * 10) / 10
          BT.averageCycle = Math.round(BT.averageCycle * 10) / 10
          SP.averageCycle = Math.round(SP.averageCycle * 10) / 10
          _this.CC = CC
          _this.BT = BT
          _this.SP = SP
        }
      }
      // 连接建立之后执行send方法发送数据
      _this.websock.onopen = function () { 
        _this.toWebsocketSendCon()
      }
      // 连接建立失败重连
      _this.websock.onerror = function () {
        _this.websock = new WebSocket("ws://" + _this.$store.state.websocketws+_this.$store.state.newroute + "/websocket-dashboardstation")
      }
      // 关闭
      _this.websock.onclose = function () {
        _this.websock = null
      }
    },
    // 向websocket发送筛选条件
    toWebsocketSendCon () {
      let _this = this
      var param = {
        'id': _this.machineId,
        'factoryId': Number(this.$store.state.defaultShopId),
        'language': this.$store.state.lang
        // 'shopId': null,
        // 'lineId': null,
        // 'machineId': _this.machineId,
        // 'typeId': null,
        // 'groupId': null,
        // 'emId': null,
        // 'eventCode': null,
        // 'startTime': null,
        // 'endTime': null,
        // 'sort': null,
        // 'pageNum': _this.pageNo
        }
      var params = JSON.stringify(param)
      // 向服务器发送消息
      _this.websock.send(params)
    },
    // 更多按钮跳转
    clickMore () {
      this.$router.push({name: 'FaultAlarmQuery', params: {factoryId: this.lineVal[0],machineId: this.lineVal[1],machineName: this.getMachineInfo.nameEn}}) 
    },
    // 获取车间列表
    // 改变机械型号触发
    changeLine(){
      this.$router.replace({
        name: 'EquipmentDashBoard', 
        params: {
          id:this.lineVal[this.lineVal.length-1]
        }
      })
      this.$parent.reload()
    },
    addFavorited(){
      let _this = this
      this.axios({
        method: 'POST',
        url: '/url/addFavoriteMachine',
        params: {
          language: _this.$store.state.lang,
          machineId: _this.machineId, // 机器的id
        }
      }).then(function (res) {
        if (res.data.success === 'true') {
          _this.isFavorited = 1
        }
        _this.$message(res.data.msg);
        _this.$refs.mychild.selectFavorite()
      })
    },
    delFavorited(){
      let _this = this
      this.axios({
        method: 'POST',
        url: '/url/deleteFavoriteMachine',
        params: {
          language: _this.$store.state.lang,
          machineId: _this.machineId, // 机器的id
        }
      }).then(function (res) {
        if (res.data.success === 'true') {
          _this.isFavorited = 0
        }
        _this.$message(res.data.msg)
        _this.$refs.mychild.selectFavorite()
      })
    },
    // 下载pdf翻页
    changeTimePage(d){
      if (d === 'l'){
        this.timeNowPage-=1
      }else{
        this.timeNowPage+=1
      }
      this.$refs.wrap.style.top = `${(this.timeNowPage-1)*-110}px`
    },
    // 下载pdf
    dlPdf(t){
      var timeStr = formatDate(new Date(t), 'yyyy-MM-dd')
      let signTime = new Date().getTime()
      this.$store.commit('nowsign', signTime)
      window.open(`/url/pdfExportGanttChartData?machineId=${this.machineId}&downloadTime=${timeStr}&language= ${this.$store.state.lang}&sign=${this.$store.state.sign}&auth_Code=${this.$store.state.authCode}&sign_time=${signTime}&route=${this.$store.state.newroute}&factory_id=${this.$store.state.factoryId}`, '_blank')
    }
  }
}
</script>
<style scoped>
.machine{
  height: 100%;
}
.machineInfo{
 position: relative;
 height: 25.57rem;
 overflow: hidden;
 box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
 border-radius: 4px;
 border:none;
}
.title_bg{
  float: left;
  width: 100%;
  height: 25.57rem;
  background-image: url(../assets/img/machine/machineBG.png);
  background-position:center;
  background-repeat: no-repeat;
  background-size: 100% auto; 
  -webkit-filter: blur(2px) brightness(180%) contrast(90%);
  -moz-filter: blur(2px) brightness(180%) contrast(90%);
  -o-filter: blur(2px) brightness(180%) contrast(90%);
  -ms-filter: blur(2px) brightness(180%) contrast(90%);
  filter: blur(2px) brightness(180%) contrast(90%);
}
.special_bg{
  background-image: url(../assets/img/machine/131BG.jpg)!important;
}
.machineInfo .rightWrap{
  float: right;
}
.lineSelect{
  width: 100px;
  margin-right: 5px;
}
.groupWrap{
  position: relative;
  top: -15.85rem;
  left:0;
}
.state{
  margin-top: 30px;

}
.stateWrap{
  width: 14.28rem;
  border-radius: 15px;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  margin: 0 auto;
  text-align: center;
  overflow: hidden;
}

.stateWrap .val{
  font-size: 3.57rem;
  font-weight: bold;
  margin-top: 1.42rem;
}
.stateWrap .val span{
  font-size: 1.42rem;
  font-weight: bold;
}
.stateWrap .dis{
  font-size: 1.14rem;
  margin-top: 2.14rem;
}
.stateWrap .bottomIcon{
  text-align: right;
  box-sizing: border-box;
  padding:0 0.71rem;
  margin-bottom: 1.42rem;
}
.stateWrap .bottomIcon span{
  font-size: 1.78rem;
  color: #CCC;
}
.stateWrap div{
  padding-top:1px; 
}
.last{
  background-color: rgba(244, 204, 28, 0.8);
}
.average{
  background-color: rgba(202, 189, 145, 0.7)
}
.best{
  background-color: rgba(122, 100, 45, 0.8);
}
.shift{
  background-color: rgba(74, 75, 185, 0.8);
}
.estimate{
  background-color: #43cf7c;
}
.current{
  background-color:rgba(100, 82, 61, 0.8)
}
.shift .dis, .estimate .dis, .current .dis{
  margin-top: 0;
}
.shift .tires, .estimate .tires, .current .tires{
  text-align: right;
  box-sizing: border-box;
  padding-right: 1.42rem;
  font-size: 1.42rem;
  height: 2.41rem;
  line-height: 2.41rem;
  font-weight: bold;
}
/* 各工位循环周期时间样式 */
.cycleTime{
  margin-top: 2.85rem;
}
.cycleTime-title{
  font-weight: bolder;
  font-size: 1.28rem;
  margin-bottom: 1.22rem;
}
.cycleBodyHead{
  display: flex;
}
.cycleBodyHead{
  background: rgba(211, 246, 255, 1);
  padding: 1.42rem 0;
}
.cycleHead-item{
  margin: 0 auto;
  width: 84px;
  line-height: 1.78rem;
  font-size: 1.14rem;
  color: #fff;
  border-radius: 0.86rem;
  background: rgba(179, 179, 179, 1);
  text-align: center;
}
.cycleHead-item-active{
  background-color: rgba(98, 98, 98, 1);
}
.headLeft{
   width: 84px;
   margin:0 54px;
}
.cycle-headRight{
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.cycleContent-item{
  display: flex;
  background: #fff;
  border-bottom: 1px solid rgba(166, 166, 166, 1);
}
.cycleContent-item:nth-child(3){
  border:none;
}
.cycleImg-box{
  margin: 2.14rem 22px 0.57rem;
}
.cycleImg{
  width: 10.57rem;
  border-radius: 10px;
  vertical-align: top;
}
.cycleModel{
  text-align: center;
  color: rgba(80, 80, 80, 1);
	font-size: 1rem;
  margin-top: 0.43rem
}
.ContentItem-left{
  width: 100%;
  display: flex;
  padding: 1.07rem 0;
}
.cycle-leftItem{
  width: 25%;
}
.cycle-second{
  width: 100%;
  margin-top: 1.07rem;
  color: rgba(0, 0, 0, 1);
  font-weight: bold;
  text-align: center;
}
.cycle-secondNum{
	font-size: 3.14rem;
	line-height: 150%;
	text-align: center;
}
.cycle-secondS{
  font-size: 1.57rem;
  margin-left: 1rem;
}
.time{
  color: rgba(117, 117, 117, 1);
	font-size: 1rem;
	line-height: 150%;
  text-align: center;
}
.short-border{
  margin-top: 2.14rem;
  width: 1px;
  height: 4.28rem;
  background: rgba(153, 153, 153, 1);
}
.lastNum{
  color: rgba(115, 115, 115, 1);
}

.tableWrap{
  margin: 40px 0 30px;
}
.titleRow label{
  font-size: 12px;
}
.datePick{
  margin: 25px 0;
}
.datePick .btns{
  float: right;
}
.typeIcon{
  color: #6772e5;
}
.pagination{
  text-align: center;
  margin-top: 35px;
}
.mcond{
  color:#808080
}
.info{
  color:#7948ea;
}
.alm{
  color:#f16a4d
}
.flt{
  color:#d43030;
}
.mask{
  display: none;
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.14);
}
.maskLong{
  height: 100%;
}
.mask p{
  text-align: center;
  font-size: 60px;
  margin-top: 85px;
  word-wrap: break-word;
}
.offlineMask{
  display: block;
  background-color: rgba(255, 255, 255, 0.8);
}
.offlineMask p{
  color:rgba(100, 91, 91, 1);
}
.notConnectedMask{
  display: block;
  background-color: rgba(45, 44, 44, 0.8);
}
.notConnectedMask p{
  color:rgba(186, 180, 180, 1);
}
.statusGroup span{
  margin-left: 55px;
}
.shiftGroup span{
  margin-left: 50px;
}
.bottomIcon p{
  display: inline-block;
  vertical-align: super;
  font-size: 0.85rem;
  color: #ccc;
  margin-right: 10px;
}
.miniTitle-box{
  display: flex;
  justify-content: space-between;
}
.miniTitle{
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 20px;
  display: inline-block;
}
.mores{
  padding: 0 10px;
  height: 34px;
}
.dlwarp .dlpagination{
  float: right;
}
.dlpagination span{
  font-size: 14px;
  margin: 0 10px;
}
.dlpagination button{
  padding: 7px;
}
.dlwarp .list{
  width: 100%;
  overflow: hidden;
  height: 100px;
  position: relative;
}
.list .cardWrap{
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.list .cardWrap .card{
  width: calc(10% - 10px);
  height: 100px;
  background-color: #fff;
  float: left;
  position: relative;
  text-align: center;
  padding: 5px 0;
  box-sizing: border-box;
  border-radius: 3px;
  box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.15);
  margin-right: 10px;
  margin-bottom: 10px;
}
.card .date{
  font-size: 30px;
  color: #ccc;
}
.card .date span{
  color: rgba(24, 144, 255, 1);
}
.card .year,.card .id{
  font-size: 14px;
  font-weight: bold;
}
.card .year{
 margin: 3px 0
}
.card .id{
  color: rgba(118, 118, 118, 1)
}
.card .dlMark{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  line-height: 100px;
  background-color: rgba(255,255,255,0.8)
}
.card .dlMark span{
  font-size: 38px;
  color:  rgba(24, 144, 255, 1);
}
.statusWrap{
  position: absolute;
  top: 3.57rem;
  left: 2.85rem;
}
.statusWrap{
  display: flex;
}
.statusWrap .status{
  width: 21.42rem
}
.statusWrap .currentShift{
  width: 18.21rem
}
.statusWrap .status,.statusWrap .currentShift{
  font-size: 1.21rem;
  margin-left: 5%;
  line-height: 2.85rem;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 10px;
  color:#fff;
}
.statusWrap .status span,  .statusWrap .currentShift span{
  padding: 0 0.71rem;
  display: block;
  float: left;
  width: 50%;
  box-sizing: border-box;
}
.statusWrap .status span:nth-child(2),.statusWrap .currentShift span:nth-child(2){
  font-weight: bold;
  text-align: center
}
</style>
